module.exports = __webpack_public_path__ + "static/img/industry1.c982ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry1.png
// module id = ezTi
// module chunks = 1